import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, ActivatedRoute, Router } from '@angular/router';

// Angular Material Imports
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';

import { ItinerarioService } from '../../../services/itinerario.service';
import { ItinerariosNavigationService } from '../../../services/itinerarios-navigation.service';
import { ItinerarioDetalleDto } from '@opb-workspace/shared';

@Component({
  selector: 'app-itinerario-detalle',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatTooltipModule
  ],
  templateUrl: './itinerario-detalle.component.html',
  styleUrls: ['./itinerario-detalle.component.scss']
})
export class ItinerarioDetalleComponent implements OnInit {
  detalle: ItinerarioDetalleDto | null = null;
  loading = true;
  error = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private itinerarioService: ItinerarioService,
    private navigationService: ItinerariosNavigationService
  ) { }

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.loadDetail(Number(id));
    } else {
      this.error = 'ID de itinerario no proporcionado';
      this.loading = false;
    }
  }

  private loadDetail(id: number): void {
    this.loading = true;
    this.error = '';

    // Read POL/POD context from query params and pass to backend
    const queryParams = this.route.snapshot.queryParams;
    const polContext = queryParams['polContext'];
    const podContext = queryParams['podContext'];

    // Backend handles all logic: filtering, ordering, transit time, isPol/isPod
    this.itinerarioService.getDetail(id, polContext, podContext).subscribe({
      next: (data) => {
        this.detalle = data;
        this.loading = false;
      },
      error: (err) => {
        console.error('Error loading itinerario detail', err);
        this.error = err.error?.message || err.message || 'Error al cargar el detalle';
        this.loading = false;
      }
    });
  }



  goBack(): void {
    this.navigationService.backToList();
  }

  print(): void {
    window.print();
  }

  downloadPdf(): void {
    if (!this.detalle) return;

    // Pass same POL/POD context used for detail view
    const queryParams = this.route.snapshot.queryParams;
    const polContext = queryParams['polContext'];
    const podContext = queryParams['podContext'];

    this.itinerarioService.downloadPdf(this.detalle.voyageId, polContext, podContext).subscribe({
      next: (blob) => {
        if (blob) {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `itinerario-${this.detalle?.vesselName}-${this.detalle?.voyageNumber}.pdf`;
          a.click();
          window.URL.revokeObjectURL(url);
        }
      },
      error: (err) => {
        console.error('Error downloading PDF', err);
      }
    });
  }

  /**
   * Format date DD/MM/YYYY
   */
  formatDate(date: string | null | undefined): string {
    return date || '-';
  }
}

